import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { CustomFacade } from '@piqet-angular/data';
import { right } from '@popperjs/core';
import { cloneDeep } from 'lodash';
import { getRolesAndPermission } from 'libs/shared/src/lib/service/helper.service';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class WasteDataGridService {
  customWastePayload: any;
  event: any;
  Access: any;
  editData = new Subject<[any, any, any]>();
  wasteDataObservable$ = this.editData.asObservable();

  copyWasteScenario = new Subject<[any, any, any]>();
  copyWasteScenarioObservable$ = this.copyWasteScenario.asObservable();

  deleteWasteScenario = new Subject<[any, any, any]>();
  deleteWasteScenarioObservable$ = this.deleteWasteScenario.asObservable();

  inlineEditingWaste = new Subject<[any, any]>();
  inlineEditingWasteObservable$ = this.inlineEditingWaste.asObservable();
  currentRoute: string = '';
  constructor(
    private CustomFacade: CustomFacade,
    private swalService: SwalService,
    private accessService: AccessPermissionService
  ) {}

  accessAllPermission(type: string) {
    const access =
      this.isAccess(type, 'edit') || this.isAccess(type, 'delete') || this.isAccess(type, 'create');
    return access;
  }

  getCustomWasteDataColumn(pathName?: any): ColDef[] {
    this.currentRoute = pathName;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Waste scenario',
      field: 'name',
      minWidth: grid_widths_map.lg_column_sm,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        const checkAccess = this.isAccess(pathName, 'edit') || this.isAccess(pathName, 'view');
        if (checkAccess) {
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess &&
            this.editData.next([
              params.data.wasteScenarioId,
              'Review custom waste scenario',
              pathName,
            ]);
        });
        return cellElement;
      },
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    {
      pathName == 'adminWasteScenarios' &&
        colDef.push({
          ...defaultColumn,
          colId: 'OrganizationName',
          headerName: 'Organization name',
          field: 'organizationName',
          minWidth: grid_widths_map.sm_column_sm,
          cellClass: 'my-permission-cursor-pointer',
          wrapText: true,
          autoHeight: true,
          resizable: false,
          filter: 'agTextColumnFilter',
          lockVisible: true,
        });
    }

    colDef.push({
      ...defaultColumn,
      colId: 'OwnerName',
      headerName: 'Owner',
      field: 'ownerName',
      minWidth: grid_widths_map.sm_column_xm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    this.accessAllPermission(pathName) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        cellRendererParams: {
          showEdit: this.isAccess(pathName, 'edit'),
          showCopy: this.isAccess(pathName, 'create'),
          showDelete: this.isAccess(pathName, 'delete'),
          value: 'customWaste',
          deleteData: (data: any, pathName: any) => {
            if (pathName == 'adminWasteScenarios') {
              this.deleteCustomConfirmation(
                data,
                '/AdminCustomWasteScenario/DeleteCustomWasteScenario',
                pathName
              );
            } else {
              this.deleteCustomConfirmation(
                data,
                '/CustomWasteScenario/DeleteCustomWasteScenario',
                pathName
              );
            }
          },
          copyData: (data: any, pathName: any) => {
            if (pathName == 'adminWasteScenarios') {
              this.copyWasteScenario.next([
                data,
                '/AdminCustomWasteScenario/SaveCopyCustomWasteScenario',
                pathName,
              ]);
            } else {
              this.copyWasteScenario.next([
                data,
                '/CustomWasteScenario/SaveCopyCustomWasteScenario',
                pathName,
              ]);
            }
          },
          editData: (data: any, pathName: any) => {
            this.editData.next([data.wasteScenarioId, 'Review custom waste scenario', pathName]);
          },
        },
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        resizable: false,
        lockVisible: true,
        lockPosition: right,
      });
    return colDef;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName.includes('admin')
      ? this.accessService.hasModulePermission(
          rolesModuleName.AdministratorWasteScenarios,
          mainModuleName.projectManagementModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.customWasteScenario,
          mainModuleName.customModule,
          type
        );
  };
  deleteCustomConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteWasteScenario.next([data, customType, pathName]);
      }
    });
  }
  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getCustomWasteDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.customWastePayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'name',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  // Will remove in future

  // getNewProcessColumns(): ColDef[] {
  //   const colDef: ColDef[] = [];

  //   // Default column for "Material"
  //   colDef.push({
  //     ...defaultColumn,
  //     colId: 'Material',
  //     headerName: 'Material',
  //     field: 'material',
  //     cellClass: 'my-permission-cursor-pointer',
  //     maxWidth: 112,
  //     wrapText: true,
  //     autoHeight: true,
  //     lockVisible: true,
  //     lockPosition: true,
  //     wrapHeaderText: true,
  //     autoHeaderHeight: true,
  //     resizable: false,
  //     editable: false,
  //     sortable: false,
  //   });

  //   // JSON Data
  //   const parsedWasteScenarios = [
  //     { id: 1, name: "Landfill %", code: "EOLID001", defaultValue: 0 },
  //     { id: 2, name: "Recycling, closed loop %", code: "EOLID002", defaultValue: 0 },
  //     { id: 3, name: "Home Composting %", code: "EOLID003", defaultValue: 0 },
  //     { id: 4, name: "Commercial Composting %", code: "EOLID004", defaultValue: 0 },
  //     { id: 5, name: "Incineration %", code: "EOLID005", defaultValue: 0 },
  //     { id: 6, name: "Energy recovery %", code: "EOLID006", defaultValue: 0 },
  //     { id: 7, name: "Open dump %", code: "EOLID007", defaultValue: 0 },
  //     { id: 8, name: "Anaerobic digestion %", code: "EOLID008", defaultValue: 0 },
  //     { id: 9, name: "Litter %", code: "EOLID009", defaultValue: 0 },
  //     { id: 10, name: "Storm Water %", code: "EOLID010", defaultValue: 0 },
  //     { id: 11, name: "Sewer %", code: "EOLID011", defaultValue: 0 },
  //     { id: 12, name: "Recycling, open loop %", code: "EOLID012", defaultValue: 0 },
  //     { id: 13, name: "Chemical recycling %", code: "EOLID013", defaultValue: 0 },
  //     { id: 14, name: "Pyrolysis/Gasification %", code: "EOLID014", defaultValue: 0 },
  //     { id: 15, name: "Open burning %", code: "EOLID015", defaultValue: 0 },
  //     { id: 16, name: "None %", code: "EOLID016", defaultValue: 0 }
  //   ];

  //   // Generate Columns Dynamically
  //   parsedWasteScenarios.forEach(scenario => {
  //     colDef.push({
  //       ...defaultColumn,
  //       colId: scenario.name.replace(/\s+/g, ''),
  //       headerName: scenario.name,
  //       field: scenario.id.toString(),
  //       cellClass: 'my-permission-cursor-pointer wasteScenarioClass',
  //       wrapText: true,
  //       autoHeight: true,
  //       lockVisible: true,
  //       lockPosition: true,
  //       wrapHeaderText: true,
  //       autoHeaderHeight: true,
  //       resizable: false,
  //       editable: false,
  //       sortable: false,
  //     });
  //   });

  //   // Actions Column
  //   colDef.push({
  //     ...defaultColumn,
  //     colId: 'actions',
  //     headerName: 'Actions',
  //     field: 'actions',
  //     sortable: false,
  //     maxWidth: grid_widths_map.sm_column_xs,
  //     cellClass: 'my-permission-cursor-pointer wasteScenarioClass',
  //     cellRenderer: "actionRenderer",
  //     pinned: 'right',
  //     cellRendererParams: {
  //       showEdit: true,
  //       showCopy: true,
  //       showDelete: true,
  //       copyData: (data: any) => {
  //         this.CustomFacade.copyWasteScenarioDataProcess(data, 'copy');
  //       },
  //       editData: (data: any) => {
  //         this.CustomFacade.updateWasteScenarioDataProcess(data, 'edit');
  //       },
  //       deleteData: (data: any) => {
  //         this.alertConfirmation(data);
  //       },
  //       copyDataEditRendarar: (data: any) => {
  //         return false;
  //       }
  //     },
  //     autoHeight: true,
  //     lockVisible: true,
  //     lockPosition: true,
  //     resizable: false,
  //   });

  //   return colDef;
  // }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.CustomFacade.deleteWasteScenarioDataProcess(data, 'delete');
      }
    });
  }
  isEmpty(val: any) {
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }
}
